export default __webpack_public_path__ + "static/media/Futura-Bold.bb156132.ttf";